<template>
  <div class="mb-3">
    <div class="row mt-4">
      <div class="col-12">
        <p class="plan-description" v-if="planDetails.plan_detail == null">
          {{ subscriptionDetail[0].description }}
        </p>
        <div v-else>
          <p
            class="plan-description"
            style="color:#EB314E;"
            v-if="
              planDetails.plan_detail.status != 'active' &&
                planDetails.plan_detail.status != 'trialing'
            "
          >
            No hemos podido realizar el cobro de tu plan a la tarjeta que
            tenemos en archivo. Por favor actualízala. Tendrás como fecha límite
            el {{ planDetails.plan_detail.next_charge }} para hacerlo, de lo
            contrario, se cancelará el plan y se perderá la configuración
            personalizada de la cuenta.
          </p>
          <p class="plan-description" v-else>
            {{ subscriptionDetail[0].description }}
          </p>
        </div>
      </div>
    </div>

    <div class="row mt-2" v-if="planDetails.plan_type != 1">
      <div class="col-12">
        <div class="d-flex flex-wrap">
          <div class="mr-2">
            <strong class="mr-1">Cobro:</strong>
            <span v-if="planDetails.plan_frecuency == 1">Mensual</span>
            <span v-else>Anual</span>
          </div>
          <div>
            <strong class="mr-1">Último pago realizado:</strong>
            <span>{{ planDetails.plan_detail.last_charge }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2" v-if="planDetails.plan_type != 1">
      <div class="col-12">
        <div class="d-flex flex-wrap">
          <div class="mr-2">
            <strong class="mr-1">Precio:</strong>
            <span
              v-if="
                planDetails.plan_detail.next_charge_amount != '' &&
                  planDetails.plan_detail.next_charge_amount != null
              "
            >
              {{ planDetails.plan_detail.next_charge_amount | currency }}
              {{ planDetails.plan_detail.currency.toUpperCase() }}
            </span>
            <div v-else>
              <span>
                {{ pricing.price | currency }}
                {{ pricing.currency.toUpperCase() }}
              </span>
            </div>
          </div>

          <div v-if="!planDetails.plan_detail.cancel_at_period_end">
            <strong class="mr-1">Próximo cobro:</strong>
            <span>{{ planDetails.plan_detail.next_charge }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2" v-if="planDetails.plan_type != 1">
      <div class="col-12">
        <div class="d-flex">
          <div>
            <strong class="mr-1">Método de pago:</strong>
            <span
              >{{ planDetails.plan_detail.brand }} **** **** ****
              {{ planDetails.plan_detail.last_four }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import data from "@/mixins/data";
import filters from "@/mixins/filters";

export default {
  mixins: [data, filters],
  props: {
    subscriptionDetail: {
      required: true,
    },
  },

  computed: {
    pricing() {
      const frecuency = this.planDetails.plan_frecuency == 1 ? "month" : "year";

      const price = this.subscriptionDetail[0].prices.find(
        (price) => price.recurring === frecuency
      );

      return price;
    },
  },
};
</script>
